// extracted by mini-css-extract-plugin
export default {"job_question":"JobDecision_job_question__2mem3","offergrid":"JobDecision_offergrid__sUVkN","rejection":"JobDecision_rejection__43zbH","button_cont":"JobDecision_button_cont__s8yHJ"};